import { status } from 'skin/event/status';
import send from './send';

const click = (obj, form, story, data, d, action) => {
	switch (obj.id) {
		case '69bd15709c4b430048750762': return send(obj, form, story, data, d, action)
		default:
			return status.action
    }
};

export default click;